import QuickstartScreenShot02Src from './receptors_2.svg'
import QuickstartScreenShot03Src from './multi_audit_3.svg'
export const ScreenShotSrc = {
  Receptors: QuickstartScreenShot02Src,
  MultiAudit: QuickstartScreenShot03Src,
}
